// extracted by mini-css-extract-plugin
module.exports = {"root":"FormItem_root__2_OgM","root_fullWidth":"FormItem_root_fullWidth__TMIjx","label":"FormItem_label__2rWmW","helperText":"FormItem_helperText__1B2To"};